import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '@app/app.component';
import { Signup } from '@app/_models';
import { AccountService, AlertService, SignupService } from '@app/_services';
import { breakpointPixels, FadvModalComponent } from '@fa-switch-sharedservices/ng-elements';
import { first } from 'rxjs';

@Component({
  selector: 'app-partner-credentialing',
  templateUrl: './partner-credentialing.component.html',
  styleUrls: ['./partner-credentialing.component.css']
})
export class PartnerCredentialingComponent implements OnInit {


  loading = false;
  //vintage Nolan D
  // firstName = "Blimpo";

  firstName: string;
  mobile: boolean;
  colAlignment: string;
  fontSize: string;
  innerWidth: any;
  copyTextSize: string;
  welcomeSize: string;
  loginSize: string;
  forgotSize: string;
  noAccountSize: string;
  buttonSize: string;
  inputSize: string;
  signup: Signup;

  @ViewChild('credentialingalertmodal') credentialingalertmodal!: FadvModalComponent;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private accountService: AccountService,
    private alertService: AlertService,
    private signupService: SignupService,
    private appComponent: AppComponent
  ) { }

  ngOnInit(): void {
    this.handleGetSignup();

  }

  handleGetSignup(){
    this.signup = this.signupService.getSignup();
    this.firstName = this.signup.firstName;

    if(this.appComponent.partner == false)
    {
      this.handleRefresh();
    }
  }

  handleViewChange() : void {
    if (this.innerWidth <= breakpointPixels.md) {
      this.colAlignment = "center";
      this.fontSize = "heading-large";
      this.mobile = true;
      this.copyTextSize = "paragraph-large";
      this.welcomeSize = "heading-large";
      this.loginSize = "heading-large";
      this.noAccountSize = "heading-large";
      this.forgotSize = "heading-large";
      this.buttonSize = "large";
      this.inputSize = "large";
    } else {
      this.colAlignment = "";
      this.fontSize = "paragraph-small";
      this.mobile = false;
      this.copyTextSize = "paragraph-small";
      this.welcomeSize = "paragraph-large";
      this.loginSize = "";
      this.noAccountSize = "";
      this.forgotSize = "";
      this.buttonSize = "medium";
      this.inputSize = "small";
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;

    if (this.innerWidth <= 860) {
      this.colAlignment = "center";
      this.fontSize = "heading-large";
      this.mobile = true;
      this.copyTextSize = "paragraph-large";
      this.welcomeSize = "heading-large";
      this.loginSize = "heading-large";
      this.noAccountSize = "heading-large";
      this.forgotSize = "heading-large";
      this.buttonSize = "large";
      this.inputSize = "large";
    }
    else {
      this.colAlignment = "";
      this.fontSize = "paragraph-small";
      this.mobile = false;
      this.copyTextSize = "paragraph-small";
      this.welcomeSize = "paragraph-large";
      this.loginSize = "";
      this.noAccountSize = "";
      this.forgotSize = "";
      this.buttonSize = "medium";
      this.inputSize = "small";
    }
  }

  nextStep(): void {
    this.accountService.login(this.signup.email, this.signup.password)
      .pipe(first())
      .subscribe({
        next: () => {
          // default to home page
          const returnUrl = '/account/credentialing';
          sessionStorage.clear();
          this.router.navigateByUrl('/signup/account/credentialing');
        },
        error: error => {
          this.alertService.error(error);
          this.loading = false;
        }
      });
  }

  handleRefresh(){
    this.appComponent.partner = true;
    var logo = this.signup.partner.logoImageContentType + this.signup.partner.logo;
    this.appComponent.partnerLogo = logo; 
  }

}

